import React from "react";
import PropTypes from "prop-types";
import TitleBar from "../Layout/titleBar";
import { Row, Col } from "react-flexbox-grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import { EditOutlined } from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import DragAndDropOferta from "../Common/dragAndDropOferta";
import "./styles.css";

const styles = () => ({
  colorSwitchBase: {
    color: "#9FA1A4",
    "&$colorChecked": {
      color: "#F57922",
      "& + $colorBar": {
        backgroundColor: "#FABC90",
        opacity: "1",
      },
    },
  },
  colorBar: {
    backgroundColor: "#000",
    opacity: "0.12",
  },
  colorChecked: {
    color: "#F57922",
  },
  colorDisabled: {
    color: "#E4E6E8",
    "&$colorChecked": {
      color: "#FABC90",
      "& + $colorBar": {
        backgroundColor: "#FABC90",
        opacity: "1",
      },
    },
  },
});

class OfertaEditado extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div /*className='crearEditarOferta'*/>
        {/* menú superior */}

        <TitleBar
          title={this.props.nombre}
          type="edicionOferta" /** tiene cancelar */ /* VER */
          handleOnBack3={this.props.handleOnCancel}
          showSearch={false}
        />

        <Row>
          <Col md={8}>
            <Paper className="myBox" style={{ marginTop: "32px", padding: "0px" }}>
              <div className="content line">
                <div style={{ height: "34px", paddingTop: "7px" }}>Datos de la oferta</div>
                {!this.props.editDatos && (
                  <IconButton
                    color="default"
                    onClick={() => this.props.setEditDatos(true)}
                    className="iconEdicion"
                  >
                    <EditOutlined />
                  </IconButton>
                )}
              </div>
              <div className="contentCampos">
                <Row>
                  <Col md={6}>
                    <TextField
                      className="myInput"
                      label={`Nombre`}
                      name="nombre"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      required={this.props.editDatos}
                      disabled={!this.props.editDatos}
                      inputProps={{ maxLength: 255 }}
                      error={this.props.error && this.props.error.nombre}
                      helperText={
                        this.props.error && this.props.error.nombre ? this.props.error.nombre : ""
                      }
                      value={this.props.nombre}
                      onChange={this.props.handleOnChange}
                    />
                  </Col>

                  <Col md={6}>
                    <TextField
                      className="myInput"
                      label="Tag"
                      name="tag"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      required={this.props.editDatos}
                      disabled={!this.props.editDatos}
                      error={this.props.error && this.props.error.tag}
                      helperText={
                        this.props.error && this.props.error.tag ? this.props.error.tag : ""
                      }
                      value={this.props.tag}
                      onChange={this.props.handleOnChange}
                    />
                  </Col>
                </Row>

                <Row style={{ marginTop: "36px" }}>
                  <Col md={6}>
                    <TextField
                      className="myInput"
                      label="Desde"
                      name="startDate"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      required={this.props.editDatos}
                      disabled={!this.props.editDatos}
                      type="date"
                      error={this.props.error && this.props.error.fechaDesde}
                      helperText={
                        this.props.error && this.props.error.fechaDesde
                          ? this.props.error.fechaDesde
                          : ""
                      }
                      value={this.props.fechaDesde}
                      onChange={(e) => this.props.handleOnClickDia({ fechaDesde: e.target.value })}
                      InputProps={{ inputProps: { max: "9999-12-31" } }}
                    />
                  </Col>

                  <Col md={6}>
                    <TextField
                      className="myInput"
                      label="Hasta"
                      name="endDate"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      required={this.props.editDatos}
                      disabled={!this.props.editDatos}
                      type="date"
                      error={this.props.error && this.props.error.fechaHasta}
                      helperText={
                        this.props.error && this.props.error.fechaHasta
                          ? this.props.error.fechaHasta
                          : ""
                      }
                      value={this.props.fechaHasta}
                      onChange={(e) => this.props.handleOnClickDia({ fechaHasta: e.target.value })}
                      inputProps={{ maxLength: 8 }}
                      InputProps={{ inputProps: { max: "9999-12-31" } }}
                    />
                  </Col>
                </Row>

                {this.props.editDatos && (
                  <Row>
                    <Col md={6}></Col>
                    <Col md={6}>
                      <div className="buttons-footer">
                        <Button
                          className="btnSecundarioFlat"
                          onClick={() => {
                            this.props.setEditDatos(false);
                            this.props.getPreOferta();
                          }}
                        >
                          CANCELAR
                        </Button>
                        <Button
                          className="btnPrincipalFlat"
                          onClick={() => {
                            this.props.handleOnSave(true);
                          }}
                        >
                          GUARDAR
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            </Paper>
          </Col>

          <Col md={4}>
            <Paper className="myBox boxImage">
              <div className="content line">
                <div style={{ height: "34px", paddingTop: "7px" }}>Cucarda</div>
                {!this.props.editImagen && (
                  <IconButton
                    color="default"
                    onClick={() => this.props.setEditImagen(true)}
                    className="iconEdicion"
                  >
                    <EditOutlined />
                  </IconButton>
                )}
              </div>

              {
                /*(!this.props.pathImg) ||*/ this.props.editImagen && (
                  <>
                    <DragAndDropOferta
                      accept="image/jpeg, image/png"
                      message="Arrastra una imagen o"
                      messageBottom={
                        this.props.ofertaSelected
                          ? this.props.ofertaSelected.observacion
                          : undefined
                      }
                      handleOnDrop={this.props.handleOnDropFile}
                      multiple={false}
                    />
                    {this.props.error && this.props.error.pathImg && (
                      <p className="imageErrorMessage">{this.props.error.pathImg}</p>
                    )}
                  </>
                )
              }

              <>
                {!this.props.pathImg && this.props.editImagen ? (
                  <div className="containerArchivoSubido">
                    <img alt="" className="image" src={this.props.pathImg}></img>
                  </div>
                ) : (
                  <div className="containerArchivoSubidoSinEdicion">
                    <img alt="" className="imageSinEdicion" src={this.props.pathImg}></img>
                  </div>
                )}
              </>

              {this.props.editImagen && (
                <Row>
                  <Col md={6}></Col>
                  <Col md={6}>
                    <div className="buttons-footer-Cucarda">
                      <Button
                        className="btnSecundarioFlat"
                        onClick={() => {
                          this.props.setEditImagen(false);
                          this.props.getPreImagen();
                        }}
                      >
                        CANCELAR
                      </Button>
                      <Button
                        className="btnPrincipalFlat"
                        onClick={() => {
                          this.props.handleOnSave(false);
                        }}
                      >
                        GUARDAR
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </Paper>
          </Col>
        </Row>
      </div>
    );
  }
}

OfertaEditado.propTypes = {
  oferta: PropTypes.object.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnSave: PropTypes.func.isRequired,
  handleOnCancel: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

OfertaEditado.defaultProps = {
  catalogos: [],
};

export default withStyles(styles)(OfertaEditado);
